import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=a88bb410&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a88bb410')) {
      api.createRecord('a88bb410', component.options)
    } else {
      api.reload('a88bb410', component.options)
    }
    module.hot.accept("./_id.vue?vue&type=template&id=a88bb410&", function () {
      api.rerender('a88bb410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplier-label/_id.vue"
export default component.exports